import React, { useEffect, useState } from 'react'
import { useObserver } from 'mobx-react-lite'
import { Text, View, ScrollView } from 'react-native'
import { TouchableOpacity } from 'react-native-web'
import { useNavigation } from '@react-navigation/core'
import DocumentComponent from '../../../../../ui/organisms/Document'
import { useStore } from '../../../../../store'
import { flow } from './flow'
import { Document } from '@linqpal/models/src/mst/Document'
import { IconCloseCross } from '../../../../../assets/icons'
import { routes } from '@linqpal/models'
import { SuccessFailurePrompt } from '../../../../../ui/molecules/SuccessFailurePrompt'
import { PromptSuccessIcon } from '../../../../../assets/icons'
import { HEADER_HEIGHT } from '../../../../../ui/atoms/CustomHeader'
import { paths } from '../../../../links'
import { useTranslation } from 'react-i18next'
import { useResponsive } from '../../../../../utils/hooks'

const ProjectFormHeader = () => {
  const { t } = useTranslation('global')
  const navigation = useNavigation()
  return (
    <View
      style={{
        width: '100%',
        height: HEADER_HEIGHT,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: 20,
      }}
    >
      <View style={{ width: 15.21 }}></View>
      <Text>{t('Projects.project_information')}</Text>
      <TouchableOpacity
        onPress={() => {
          if (navigation.canGoBack()) navigation.goBack()
          else
            navigation.navigate(paths.Console.InvoicesToPay._self, {
              screen: paths.Console.InvoicesToPay.Listing,
            })
        }}
      >
        <IconCloseCross style={{ width: 15.21, height: 15.21 }} />
      </TouchableOpacity>
    </View>
  )
}

export default function ProjectForm({ navigation, route }) {
  const { t } = useTranslation('global')
  const [projectForm, setProjectForm] = useState(
    Document.create({ type: 'project_form', current: flow.initial }),
  )
  const [
    createProjectSuccessModalVisibility,
    setCreateProjectSuccessModalVisibility,
  ] = useState(false)
  const { userStore } = useStore()
  const { mobileWidth, screenHeight } = useResponsive()

  useEffect(() => {
    userStore.fetchDocument('loan_application')
  }, [])
  const document = useObserver(() => projectForm)

  const [group, item] = useObserver(
    () => (document && document.current) || flow.initial,
  ).split('.')
  const invoiceToAdd = route.params?.invoice //from ProjectSelectionBottomModal //if user creates a new project directly after paying for invoice

  const [createdProject, setCreatedProject] = useState({})

  const onSuccessAlertClose = () => {
    setCreateProjectSuccessModalVisibility(false)
    navigation.navigate(paths.Console.Projects.List)
  }
  useEffect(() => {
    return () => {
      setProjectForm(Document.create({ type: 'project_form' }))
    }
  }, [])

  useEffect(() => {
    if (document.filled.includes('projectInfo.projectName')) {
      //this is the common endpoint for every form flow
      //if project info form is complete, create the project
      let invoices = []
      if (invoiceToAdd) {
        invoices = [invoiceToAdd._id]
      }
      routes.projects
        .create(
          { document: document, invoices: invoices },
          invoiceToAdd?.project,
        )
        .then((res) => {
          setCreatedProject(res.project)
          setCreateProjectSuccessModalVisibility(true)
          navigation.navigate(paths.Console.Projects.Details, {
            project: res.project,
          })
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [item])

  const groupFlow = flow[group]

  const getMessage = (invoiceToAdd, createdProject) => {
    if (invoiceToAdd) {
      return (
        <Text>
          {t('Projects.your_invoice_from')}
          <Text style={{ fontWeight: 600 }}>
            {invoiceToAdd?.company.name}
          </Text>{' '}
          {t('Projects.was_added')}
          <Text style={{ fontWeight: 600 }}>{createdProject.name}</Text>
        </Text>
      )
    } else {
      return (
        <Text>
          {t('Projects.your_project')}
          <Text style={{ fontWeight: 600 }}>{createdProject.name}</Text>
          {t('Projects.been_added')}
        </Text>
      )
    }
  }
  return (
    <>
      <View style={{ width: mobileWidth }}>
        <View style={{ height: HEADER_HEIGHT }}>
          <ProjectFormHeader />
        </View>
        <ScrollView
          style={{ height: screenHeight - HEADER_HEIGHT }}
          contentContainerStyle={{ paddingBottom: 10 }}
        >
          {group !== 'review' && (
            <DocumentComponent
              flow={flow}
              initial={flow.initial}
              document={document}
              type="project_form"
              closeMe={() => navigation.goBack()}
            />
          )}
          {group === 'review' && <groupFlow.component document={document} />}
        </ScrollView>
      </View>
      <SuccessFailurePrompt
        visible={createProjectSuccessModalVisibility}
        onDismiss={onSuccessAlertClose}
        title="Project Added"
        icon={<PromptSuccessIcon />}
        message={getMessage(invoiceToAdd, createdProject)}
        buttonData={{
          title: t('Projects.view_project'),
          onPress: () => {
            setCreateProjectSuccessModalVisibility(false)
            navigation.navigate(paths.Console.Projects.Details, {
              project: createdProject,
            })
          },
          contentStyle: { width: '100%' },
        }}
      />
    </>
  )
}
